import { ReactComponent as CardIconSVG } from 'assets/svg/card-icon.svg';
import styled from 'styled-components';

export const CardIcon = styled(CardIconSVG)`
  width: 28px;
  color: ${({ theme }) => theme.colors.silver400};
  margin-right: 4px;
`;
